import Spinner from "react-bootstrap/Spinner";
import styles from "./overlay-container.less";

export const OverlayContainer = () => {
    const spinners = [0, 1, 2];
    return (
        <div className={styles.overlayContainer} role="dialog">
            <div className={styles.overlayImage}>
                {spinners.map(spinner => (
                    <Spinner key={spinner} className={styles.spinner} animation={"grow"} />
                ))}
            </div>
        </div>
    );
};